import Card from "@amzn/meridian/card";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import {
  setInputText,
  setShowResult,
} from "src/components/pages/home/store/chatSlice";
import {
  ERGONA_QUESTIONS,
  POLICY_QUESTIONS,
  SAIGE_METRICS_QUESTIONS,
} from "src/constants/constants";
import { useAppDispatch, useAppSelector } from "src/store/store";
import "./chatCards.scss";

const ChatCards = ({ inputRef, isOnMcpRoute }) => {
  const dispatch = useAppDispatch();
  const { isAdministrator } = useAppSelector((state) => state.user);
  const fillInput = (prompt: string) => {
    dispatch(setShowResult(false));
    dispatch(setInputText(prompt));
    inputRef.current.focus();
  };

  return (
    <div className="chat-cards">
      {isOnMcpRoute ? (
        <Row widths="fill">
          {(isAdministrator
            ? SAIGE_METRICS_QUESTIONS()
            : ERGONA_QUESTIONS()
          ).map((question, index) => (
            <div key={index} className="safety-cards saige-metrics-cards">
              <Column>
                <Card onClick={() => fillInput(question)}>
                  <Text className="chat-card" type="b400">
                    {question}
                  </Text>
                </Card>
              </Column>
            </div>
          ))}
        </Row>
      ) : (
        <Row widths="fill">
          {POLICY_QUESTIONS().map((question, index) => (
            <div key={index} className={"safety-cards saige-safety-cards"}>
              <Column>
                <Card onClick={() => fillInput(question)}>
                  <Text className="chat-card" type="b400">
                    {question}
                  </Text>
                </Card>
              </Column>
            </div>
          ))}
        </Row>
      )}
    </div>
  );
};

export default ChatCards;
